export default (sitemap: SitemapBuilder) =>
{
    sitemap.find('[[[Strona główna]]]').after('[[[Bezpieczeństwo]]]', [
        {
            name: '[[[Tokeny dostępu]]]',
            route: 'standard-pats',
            icon: 'far fa-fw fa-key'
        }
    ]);

    sitemap.find('[[[System]]]', '[[[Administracja]]]').after('[[[Role i uprawnienia]]]', [
        {
            name: '[[[Organizacja]]]',
            route: 'standard-units',
            icon: 'far fa-fw fa-sitemap',
            auth: { all: ['OrganizationPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie działu]]]',
                    route: 'standard-units-add',
                    auth: { all: ['OrganizationPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja działu]]]',
                    route: 'standard-units-edit',
                    auth: { all: ['OrganizationPermissions@Edit'], any: [] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Zespoły]]]',
            route: 'standard-teams',
            icon: 'far fa-fw fa-users',
            auth: { all: ['TeamsPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie zespołu]]]',
                    route: 'standard-teams-add',
                    auth: { all: ['TeamsPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja zespołu]]]',
                    route: 'standard-teams-edit',
                    auth: { all: ['TeamsPermissions@Edit'], any: [] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Zastępstwa]]]',
            route: 'standard-substitutions',
            icon: 'far fa-fw fa-user-group',
            auth: { all: ['SubstitutionsPermissions@View'], any: [] },
            children: [
                {
                    name: '[[[Dodanie zastępstwa]]]',
                    route: 'standard-substitutions-add',
                    auth: { all: ['SubstitutionsPermissions@Edit'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja zastępstwa]]]',
                    route: 'standard-substitutions-edit',
                    auth: { all: ['SubstitutionsPermissions@Edit'], any: [] },
                    visible: false
                }
            ]
        }
    ]);

    sitemap.find('[[[System]]]', '[[[Ustawienia]]]').push([
        {
            name: '[[[Źródła LDAP]]]',
            route: 'standard-ldap',
            icon: 'far fa-fw fa-shield-alt',
            auth: { all: ['AdminPermissions@LdapConfig'], any: [] },
            children: [
                {
                    name: '[[[Dodanie źródła]]]',
                    route: 'standard-ldap-add',
                    auth: { all: ['AdminPermissions@LdapConfig'], any: [] },
                    visible: false
                },
                {
                    name: '[[[Edycja źródła]]]',
                    route: 'standard-ldap-edit',
                    auth: { all: ['AdminPermissions@LdapConfig'], any: [] },
                    visible: false
                }
            ]
        },
        {
            name: '[[[Bramka SMS]]]',
            route: 'standard-sms',
            icon: 'far fa-fw fa-shield-alt',
            auth: { all: ['AdminPermissions@Sms'], any: [] }
        },
        {
            name: '[[[Firebase]]]',
            route: 'standard-firebase',
            icon: 'far fa-fw fa-shield-alt',
            auth: { all: ['AdminPermissions@Firebases'], any: [] }
        },
        {
            name: '[[[Paleta kolorów]]]',
            route: 'standard-colors',
            icon: 'far fa-fw fa-palette',
            auth: { all: ['AdminPermissions@Colors'], any: [] }
        }
    ]);
};
